<template>
  <div class="page detail page-detail">
    <div class="top" v-if="!is_app">
      <img class="logo" :src="logo" />
      <a
        class="btn"
        href="https://a.app.qq.com/o/simple.jsp?pkgname=com.redirect.wangxs.qiantu"
        >在官方APP中打开</a
      >
    </div>
    <div :class="appClass">
      <div class="title">{{ detail.mname }}</div>
      <div class="cover">
        <img class="cover-img" :src="detail.image" />
        <div class="sta sta-ing">{{ newStatus }}</div>
        <!-- <div class="sta sta-over" style="display: none">已截稿</div> -->
        <div class="total-num" v-if="detail.is_works_show == 1 && detail.id!=10326">{{ detail.total }}</div>
      </div>
      <div class="btngroup-tab" v-if="isShowContribute && isShowGroupContribute">
        <a :class="!ifShowGroupInfo?'cur':''" href="javascript:void(0)" @click="notShowGroupInfo">赛事介绍</a>
        <a :class="ifShowGroupInfo?'cur':''" href="javascript:void(0)" @click="showGroupInfo">战队信息</a>
      </div>
      <!-- 所属协会 -->
      <div class="btngroup-tab" v-if="detail.is_assoc_show">
        <a class="cur" href="javascript:void(0)">赛事介绍</a>
        <a class="" href="javascript:void(0)" @click="isShowSelorg = true">所属单位</a>
      </div>
      <!-- 所属协会 -->
      <div class="text" v-html="detail.requirements" v-if="!ifShowGroupInfo">
        {{ detail.requirements }}
      </div>
      <div class="text" v-if="isShowContribute && isShowGroupContribute && ifShowGroupInfo">
        <!-- <img class="group-ingo-img" v-for="(item,index) in groupInfoImg" :src="item" :key="index"> -->
        <div class="group-info-con" :style="`background: url(https://match.pai2345.com/static/images/team/group_${id}.png) no-repeat top center`">
          <div class="group-item" v-for="(item,index) in groups" :key="index">
            <div class="group-name"><span><em>{{item.groupName}}</em></span></div>
            <div class="group-leader">
              <div class="label">团长</div>
              <div>{{item.leader}}</div>
            </div>
            <div class="group-members">
              <div class="label">团员</div>
              <ul>
                <li v-for="(subItem,SubIdx) in item.members" :key="SubIdx">{{subItem}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <img class="btn-backtop" src="../../static/images/arrow-1.png" @click="backTop" v-if="scrollTop>300">
    </div>
    <div class="bottom">
      <router-link class="btn-w" v-if="detail.is_works_show == 1" :to="'/detail/' + id + '/works'"
        >已投稿作品</router-link
      >
      <a
        class="btn-w"
        v-if="isShowContribute"
        href="javascript:;"
        @click="contribute"
        >我要投稿</a
      >
      <a
        class="btn-w btn-group"
        v-if="isShowContribute && isShowGroupContribute"
        href="javascript:;"
        @click="contribute(1)"
        >战队投稿</a
      >
      <a
        class="btn-w"
        v-if="isShowNotice"
        href="javascript:;"
        @click="goAward"
        >{{ detail.notice_title }}</a
      >
      <!-- <router-link class="btn-w" :to="'/detail/' + id + '/myworks'"
        >我的作品</router-link
      > -->
      <a class="btn-w" href="javascript:;" @click="goMyworks">我的作品</a>
      <!-- 如果我要投稿和获奖作品都显示，显示上箭头 -->
      <a
        class="btn-wMore"
        v-if="
          (isShowContribute && isShowNotice) ||
            (isShowContribute && isShowGroupContribute)
        "
        href="javascript:;"
        @click="isShowMoreDetail = true"
      ></a>
    </div>
    <!-- 显示更多按钮 -->
    <van-overlay :show="isShowMoreDetail">
      <div class="more-detail">
        <router-link class="btn-w" v-if="detail.is_works_show == 1" :to="'/detail/' + id + '/works'"
          >已投稿作品</router-link
        >
        <a
          class="btn-w"
          v-if="isShowContribute"
          href="javascript:;"
          @click="contribute"
          >我要投稿</a
        >
        <a
          class="btn-w btn-group"
          v-if="isShowContribute && isShowGroupContribute"
          href="javascript:;"
          @click="contribute(1)"
          >战队投稿</a
        >
        <router-link
          class="btn-w"
          :to="'/detail/' + id + '/award'"
          v-if="isShowNotice"
          >{{ detail.notice_title }}</router-link
        >
        <a class="btn-w" href="javascript:;" @click="goMyworks">我的作品</a>
        <!-- 如果我要投稿和我的作品都显示，显示上箭头 -->
        <a
          href="javascript:;"
          class="btn-w close-detail"
          @click="isShowMoreDetail = false"
          >取消</a
        >
      </div>
    </van-overlay>
    <van-overlay :show="isShowForm">
      <div class="basic">
        <div class="wrap">
          <div class="hd">
            投稿信息基础核对
            <span class="close" @click="isShowForm = false">
              <img :src="close" alt="加载失败" style="width: 100%;" />
            </span>
          </div>
          <van-form @submit="submitBasic">
            <van-field
              v-model="basicInfo.nickname"
              class="required"
              name="昵称"
              label="昵称"
              placeholder="昵称"
              :rules="[{ required: true, message: '不能为空，以便后续联系' }]"
            />
            <van-field
              v-model="basicInfo.realname"
              class="required"
              name="真实姓名"
              label="真实姓名"
              placeholder="真实姓名"
              :rules="[{ required: true, message: '不能为空，以便后续联系' }]"
            />
            <div class="van-cell van-field required">
              <div class="van-cell__title van-field__label">
                <span>所在地</span>
              </div>
              <div class="van-cell__value van-field__value">
                <input
                  class="van-field__control input-btn"
                  type="text"
                  placeholder="请选择省份"
                  v-model="basicInfo.province"
                  @click="isShowProvince = true"
                  readonly
                />
                <input
                  class="van-field__control"
                  type="text"
                  placeholder="请选择地级市"
                  v-model="basicInfo.city"
                  @click="isShowCity = true"
                  readonly
                />
              </div>
            </div>
            <div class="van-cell van-field__body">
              <div class="van-cell__title van-field__label">
                <span>手机号</span>
              </div>
              <div class="van-cell__value van-field__value normal">
                <!-- <van-picker show-toolbar title="标题" :columns="area" /> -->
                <!-- <div class="van-field__body"></div> -->
                <span class="mobile">{{ basicInfo.mobile }}</span>
              </div>
            </div>
            <div style="margin: 16px;">
              <p>请核对并完善参赛信息以便评选后联系您</p>
              <van-button round block type="warning" native-type="submit">
                确认提交
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="isShowProvince" position="bottom">
      <van-picker
        show-toolbar
        title="请选择省份"
        :columns="province"
        :default-index="provinceIndex"
        @cancel="isShowProvince = false"
        @confirm="confirmProvince"
      />
    </van-popup>
    <van-popup v-model="isShowCity" position="bottom">
      <van-picker
        show-toolbar
        title="请选择地级市"
        :default-index="cityIndex"
        :columns="city"
        @cancel="isShowCity = false"
        @confirm="confirmCity"
      />
    </van-popup>
    <van-popup v-model="isShowSelorg" position="bottom">
      <van-picker
        show-toolbar
        title="请选择所属单位"
        :columns="selorgColumns"
        @cancel="isShowSelorg = false"
        @confirm="submitSelorg"
        @change="changeSelorg"
      />
    </van-popup>
    <!-- 显示投稿分类 -->
    <van-overlay :show="isShowContributeType">
      <van-picker
        class="contribute-type"
        show-toolbar
        title="请选择分类"
        :columns="matchType"
        @cancel="hideContributeType"
        @confirm="confirmContributeType"
      />
    </van-overlay>

    <!-- 俱乐部弹窗 -->
    <van-dialog
      v-model="allowClubDialog"
      title="温馨提示："
    >
      <div style="font-size:16px;height:100px;margin:15px;">
        根据征稿要求，本次活动仅限大扬影像会员、大扬学院会员及五六公社社员参加，热诚欢迎各地影友入会，积极投稿参赛。
        <br />入会联系人：温晓斌
        <br />联系电话：18060778759
      </div>
    </van-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
// import Head from "@/layouts/Head.vue";
// import Lightbox from "@/components/Lightbox";
// import store from "@/store";
// import area from "@/utils/area";
export default {
  name: "Detail",
  components: {
    // Lightbox
  },
  data() {
    return {
      showPicker: false,
      logo: require("../../static/images/logo.png"),
      close: require("../../static/images/close-1.png"),
      // 缓存 matchList 初始化列表，用 list 筛选赋值 matchList
      id: this.$route.params.id,
      detail: {
        tg_status: 0,
        match_group: [],
        button_show: 0,
        prizes_rs: 0,
        limit_province: "",
        limit_city: "",
        requirements: "",
        image: "",
      },
      isShowContribute: false,
      isShowGroupContribute: false, // 是否显示战队投稿（要和投稿按钮同步，不能投稿的同时也不能战队投稿）
      isGroup: false,
      status: "",
      matchType: [],
      // 截稿样式
      statusClass: "sta sta-ing",
      // 是否隐藏投稿按钮
      isHideContribute: false,
      // 分享
      imgWeibo: require("@/static/images/weibo.png"),
      imgWx: require("@/static/images/weixin.png"),
      imgQq: require("@/static/images/qq.png"),
      // 是否显示获奖作品
      isShowAward: false,
      // 模拟是否登记过信息 正式应异步获取
      isValidated: true,
      // 是否显示登记基础信息的弹层
      isShowForm: false,
      isShowProvince: false,
      isShowCity: false,
      provinceIndex: 0,
      cityIndex: 0,
      // 基础信息表单
      basicInfo: {
        nickname: "",
        realname: "",
        province: "",
        city: "",
        mobile: 1,
      },
      infoRules: {
        nickname: [
          { required: true, message: "昵称不能为空", trigger: "blur" },
        ],
        realname: [
          { required: true, message: "真实姓名不能为空", trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择所在地", trigger: "change" },
        ],
        city: [
          { required: true, message: "请选择地级城市", trigger: "change" },
        ],
        // phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }]
      },
      // 投票类型 弹层开关
      isShowContributeType: false,
      // 显示更多按钮
      isShowMoreDetail: false,
      // matchGroupList: [
      // ],
      matchGroup: [],
      type: "",
      // 省市级联
      area: {},
      province: [],
      city: [],
      // 是否显示获奖公告/作品
      isShowNotice: false,
      isNotice: false,
      noticeLink: "",
      // 是否在app中打开
      is_app: false,
      appClass: "desc-main",
      // 接口事件设置状态，防止连点
      isClick: true,
      ifShowGroupInfo: false,
      scrollTop: 0,
      // 所属协会
      isShowSelorg: false,
      selorgIndex: "",
      selorgColumns:[],
      groups:[],
      // 是否俱乐部投稿
      allowClub: false,
      allowClubDialog: false,
    };
  },
  computed: {
    newStatus: function() {
      // computed的属性必须是data里面显式声明的响应式属性
      let statusAry = {
        0: "即将开始",
        1: "征稿中",
        2: "已截稿",
      };
      // console.log(this.detail);
      return statusAry[this.detail.tg_status];
      // return this.detail.tg_status;
    },
  },
  methods: {
    confirmProvince(value) {
      this.basicInfo.province = value;
      this.isShowProvince = false;
      this.initCity(this.basicInfo.province);
      // for (let i = 0, len = this.province.length; i < len; i++) {}
      this.provinceIndex = this.province.indexOf(value);
    },
    confirmCity(value) {
      this.basicInfo.city = value;
      this.cityIndex = this.city.indexOf(value);
      this.isShowCity = false;
    },
    init() {
      this.tools.detail_cache({ id: this.id }, true).then((res) => {
        Object.assign(this.detail, res);
        // console.log(this.detail);
        this.detail.is_works_show;
        // 判断是否战队投稿
        if(this.detail.contribution == 1){
          this.isShowGroupContribute = true;
          // 获取战队信息
          let that = this;
          this.axios.post("/team/teamList", { mid: this.detail.id }).then((res) => {
            that.groups = res.data.data;
          });
        }
        // 判断俱乐部投稿
        if(this.detail.club != ''){
          this.allowClub = true;
        }
        document.title = this.detail.mname;
        // 状态初始化
        this.isShowContribute =
          this.detail.button_show && this.detail.tg_status == 1;
        this.isShowNotice =
          (this.detail.prizes_rs == 1 && this.detail.is_popup == 0) ||
          (this.detail.notice_show == 1 && this.detail.is_popup == 1);
        this.isNotice =
          this.detail.notice_show == 1 && this.detail.is_popup == 1;
        // 获奖链接
        this.noticeLink = this.detail.notice_link;
        // 所属协会初始化
        let index1 = 0;
        // this.detail.orgLevel = 1;
        if(this.detail.orgLevel == 2){
          let assoc = this.detail.assoc.split("_");
          let assoc_0 = this.detail.orgList[0];
          if(assoc[0]){
            assoc_0 = assoc[0];
            for(var key in this.detail.orgList){
              if(this.detail.orgList[key] == assoc_0){
                index1 = parseInt(key);
              }
            }
          }
          let index2 = 0;
          if(assoc[1]){
            for(var key2 in this.detail.orgList2[assoc_0]){
              if(this.detail.orgList2[assoc_0][key2] == assoc[1]){
                index2 = parseInt(key2);
              }
            }
          }
          this.selorgColumns = [
            {
              values: this.detail.orgList,
              defaultIndex:index1
            },
            {
              values: this.detail.orgList2[assoc_0],
              defaultIndex:index2
            }
          ];
        }else{
          for(var key3 in this.detail.orgList){
            if(this.detail.orgList[key3] == this.detail.assoc){
              index1 = parseInt(key3);
            }
          }
          this.selorgColumns = [
            {
              values: this.detail.orgList,
              defaultIndex: index1
            }
          ];
        }
      });

      this.axios.post("/match/areas").then((res) => {
        // console.log(res);
        this.area = res.data.data;
        // 省市初始化
        for (var key in this.area) {
          // if (area[key] != "") this.province.push(key);
          this.province.push(key);
        }
        // this.basicInfo.province = this.province[0];
      });

    },
    initCity(province) {
      this.city = this.area[province];
      this.basicInfo.city = typeof this.city == "object" ? this.city[0] : "";
      // this.basicInfo.city = this.city[0];
      this.cityIndex = 0;
      // console.log(province, this.city);
    },
    // 选择所属协会
    changeSelorg(picker, values) {
      //在change 第一列的时候，动态更改第二列的数据
      //setColumnValues是vant自带的实例方法
      //第一个参数是列数，从0开始；第二个参数是第二列应该显示的数据
      if(this.detail.orgList2[values[0]]){
        picker.setColumnValues(1, this.detail.orgList2[values[0]]);
      }else{
        picker.setColumnValues(1, []);
      }
    },
    submitSelorg(value) {
      //将选中的文字和对应的id拿出来使用
      // this.village_name = value[0].name + ',' + value[1].name;
      // this.village_id = value[0].id;
      // this.garage_id = value[1].id;
      let assoc = value[0];
      if(value[1]){
        assoc = assoc+'_'+value[1];
      }
      let that = this;
      this.axios.post("/match/editAssoc", {match_id: that.id, assoc: assoc}).then((res) => {
        if (res.data.code == 200) {
          this.detail.assoc = assoc;
        }
        this.isShowSelorg = false;
      });
    },
    contribute(isGroup) {
      // 判断是否点击战队投稿
      if (isGroup != undefined && isGroup == 1) {
        this.isGroup = true;
      } else {
        this.isGroup = false;
      }
      // 判断是否登录，并且是否登记完成基础信息
      // 不使用vuex，避免用户修改地区后还调用缓存信息导致不符合投稿要求的问题
      if (this.isShowGroupContribute) {
        this.checkInfo(this.contributeGroup);
      } else {
        this.checkInfo();
      }

      // 判断是否协会投稿
      if(this.detail.is_assoc_show && !this.detail.assoc){
        this.isShowSelorg = true;
      }
    },
    checkInfo(callback) {
      if (this.isClick) {
        this.isClick = false;
        // 防重复点击
        setTimeout(() => {
          this.isClick = true;
        }, 2000);
        // 每次投稿检查是否登录
        this.axios
          .post("/match/checktUserInfo")
          .then((res) => {
            var data = res.data.data;
            if (res.data.code == 200) {
              // 已登录
              this.$store.commit("changeLogin", true);
              this.$store.commit("changeUserInfo", res.data.data);
              // console.log("login status: ", this.$store.state);
              // 已登录
              if (typeof callback == "function") {
                this.initUserInfo(data, callback);
              } else {
                this.initUserInfo(data);
              }
            }
          })
          .catch((err) => {
            console.log(err);
            /* eslint-disable */
            // 调用passport
            passportLogin.login();
            /* eslint-enable */
          });
      }
    },
    initUserInfo(data, callback) {
      // 判断基础信息是否完整
      // let isValidated = false;
      let isValidated =
        data.mobile != "" &&
        data.realname != "" &&
        data.province != "" &&
        data.nickname != "";

      // console.log("valid:", isValidated);
      if (isValidated) {
        // 判断是否有地区限制
        if (
          this.detail.limit_province != "" &&
          this.detail.limit_province != data.province
        ) {
          this.$dialog.alert({
            message: "抱歉，本赛事仅针对特定地区摄影师开放",
          });
        } else if (
          this.detail.limit_province != "" &&
          this.detail.limit_city != "" &&
          (this.detail.limit_province != data.province ||
            this.detail.limit_city != data.city)
        ) {
          this.$dialog.alert({
            message: "抱歉，本赛事仅针对特定地区摄影师开放",
          });
        } else {
          // 如果已经登记过信息，校验投稿分类
          this.isShowForm = false;

          // 俱乐部特殊判断
          if(this.allowClub == true){
            this.axios.get("/match/checkClub?club="+this.detail.club).then((res) => {
              if (res.data.code != 200) {
                this.allowClubDialog = true;
                return false;
              }else{
                // 判断是否战队成员
                if (typeof callback == "function") {
                  callback();
                } else {
                  this.dealMatchGroup(this.detail.match_group);
                }
              }
            });
          }else{
            // 判断是否战队成员
            if (typeof callback == "function") {
              callback();
            } else {
              this.dealMatchGroup(this.detail.match_group);
            }
          }
        }
      } else {
        // 否则先弹 基础信息 登记表单，提交登记表单后，跳转到校验投稿分类
        // 初始化已有的用户信息
        // console.log(data);
        this.basicInfo.nickname = data.nickname;
        this.basicInfo.realname = data.realname;
        this.basicInfo.province = data.province;
        this.initCity(this.basicInfo.province);
        this.basicInfo.city = data.city;
        // console.log(this.province)
        this.provinceIndex =
          this.basicInfo.province == ""
            ? 0
            : this.province.indexOf(this.basicInfo.province);
        this.cityIndex =
          this.basicInfo.city == ""
            ? 0
            : this.city.indexOf(this.basicInfo.city);
        this.basicInfo.nickname = data.nickname;
        this.basicInfo.mobile = data.mobile;
        this.isShowForm = true;
        // console.log("basicInfo: ", this.basicInfo);
      }
    },
    // 提交基础信息核对
    submitBasic() {
      if (
        this.basicInfo.province == "" ||
        this.basicInfo.city == "" ||
        this.basicInfo.city == "default"
      ) {
        this.$toast.fail("请选择所在地");
      } else {
        this.axios
          .post("/match/setUserInfo", {
            ...this.basicInfo,
          })
          .then((res) => {
            // console.log("ressss:", res);
            if (res.data.code == 200 || res.code == 200) {
              this.isShowForm = false;
              this.checkInfo();
              // this.contribute();
            }
            if (res.data.code == 0 || res.code == 0) {
              this.$toast.fail(res.data.msg);
            }
          });
      }
    },
    dealMatchGroup(matchGroup) {
      // console.log(matchGroup);
      this.matchType = [];
      if (matchGroup.length > 1) {
        // 如果大于1，显示赛事投稿类型 弹层
        for (let item of matchGroup) {
          this.matchType.push(item.groupname);
        }
        // console.log(this.matchType)
        this.isShowContributeType = true;
        // 选择分类后，根据gid跳转
      } else {
        // 如果小于1，直接根据gid跳转投稿页
        // matchGroup应该至少=1；为空则为数据错误
        this.goContribute(matchGroup[0].gid);
      }
    },
    goContribute(gid) {
      // console.log('gid: ',gid);
      var group = this.tools.return_group(this.detail.match_group, gid);
      // console.log(group);
      if (group) {
        let type = group.type;
        let isGroup = group.is_group_des;
        if (type.length == 1) {
          // 判断是否组照,直接跳转到对应页面
          this.linkTo(type[0], isGroup, gid);
        } else {
          // 判断有几个投稿类型，显示对应选择类型页
          // this.$
          let paramsType = "";
          paramsType += type.indexOf("1") > -1 ? "single" : "";
          paramsType +=
            type.indexOf("2") > -1 ? (isGroup == 0 ? "multi" : "group") : "";
          paramsType += type.indexOf("3") > -1 ? "video" : "";
          this.$router.push({
            path: `/contribute/${this.id}/${paramsType}`,
            query: { group: gid },
          });
        }
      }
    },
    linkTo(type, isGroup, gid) {
      // console.log("typeShow: ", type[0]);
      switch (type[0]) {
        case "1":
          // "/contribute/" + this.$route.params.id + "/single"
          this.$router.push({
            path: `/contribute/${this.id}/0/single`,
            query: { group: gid },
          });
          break;
        case "2":
          isGroup == 0
            ? this.$router.push({
                path: `/contribute/${this.id}/0/multi`,
                query: { group: gid },
              })
            : this.$router.push({
                path: `/contribute/${this.id}/0/group`,
                query: { group: gid },
              });
          break;
        default:
          this.$router.push({
            path: `/contribute/${this.id}/0/video`,
            query: { group: gid },
          });
          break;
      }
    },
    hideContributeType() {
      this.isShowContributeType = false;
    },
    confirmContributeType(val, index) {
      this.goContribute(this.detail.match_group[index].gid);
    },
    goAward() {
      if(this.noticeLink != ''){
        window.location.href = this.noticeLink;
      }else{
        let path = this.isNotice
          ? "/detail/" + this.id + "/award?showNotice=true"
          : "/detail/" + this.id + "/award";
        this.$router.push({ path });
      }
    },
    goMyworks() {
      if (this.isShowGroupContribute) {
        // 如果是战队投稿赛事，需要判断是否战队成员
        this.checkInfo(() => {
          let uid = this.$store.state.userInfo.uid;
          this.axios
            .post(this.tools.api.isTeamMember, { uid })
            .then((res) => {
              let data = res.data;
              if (data.code == 200 && data.data != null) {
                this.$router.push({
                  path: "/detail/" + this.id + "/team/",
                  query: {
                    tid: data.data.tid,
                    uid: data.data.uid,
                    gid: this.detail.match_group[0].gid,
                  },
                });
              } else if (data.code == 200 && data.data == null) {
                this.$router.push({
                  path: "/detail/" + this.id + "/myworks",
                });
              }
            })
            .catch(() => {
              this.$toast("对不起，您不是战队成员。请点击\"我要投稿\"进行个人投稿");
            });
        });
      } else {
        this.$router.push({
          path: "/detail/" + this.id + "/myworks",
        });
      }
    },
    contributeGroup() {
      let uid = this.$store.state.userInfo.uid;
      let mid = this.id;
      this.axios
        .post(this.tools.api.isTeamMember, { uid, mid })
        .then((res) => {
          let data = res.data;
          if (data.code == 200 && data.data != null) {
            if (this.isGroup) {
              this.$router.push({
                path: "/detail/" + this.id + "/team/",
                query: {
                  tid: data.data.tid,
                  uid: data.data.uid,
                  gid: this.detail.match_group[0].gid,
                },
              });
            } else {
              this.$toast("对不起，您不是战队成员。请点击\"我要投稿\"进行个人投稿");
            }
          } else if (data.code == 200 && data.data == null) {
            if (this.isGroup) {
              this.$toast("对不起，您不是战队成员。请点击\"我要投稿\"进行个人投稿");
            } else {
              this.dealMatchGroup(this.detail.match_group);
            }
          }
        })
        .catch(() => {
          this.$toast("对不起，您不是战队成员。请点击\"我要投稿\"进行个人投稿");
        });
    },
    showGroupInfo(){
      this.ifShowGroupInfo = true;
    },
    notShowGroupInfo(){
      this.ifShowGroupInfo = false
    },
    backTop(){
      window.scrollTo(0,0);
    },
    handleScroll(){
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
  },
  created() {
    this.init();
    // console.log(this.$store.state);
    if (this.tools.openInWebview()) {
      this.is_app = true;
      this.appClass = "desc-main desc-app";
      // $(".desc-main").css("padding-top", 0);
    }
    var data = { url: window.location.href, id: this.id };
    this.tools.wx_share_init(data);
  },
  mounted() {
    // 跳转路由之前会先执行这个
    window.addEventListener('scroll',this.handleScroll,true)
  },
};
</script>

<style lang="scss">
.van-overlay {
  z-index: 9;
}
// .page-detail {
//   // padding-bottom: 100px;
// }
.detail {
  .text {
    padding-bottom: 120px;
  }
  .basic {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    width: 90%;
    left: 5%;
    background: #fff;
    .hd {
      background: #ff976a;
      color: #fff;
      height: 80px;
      font-size: 14px; /* no */
      line-height: 80px;
      text-indent: 40px;
      position: relative;
      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        img {
          display: block;
        }
      }
    }
    .wrap {
      position: relative;
      height: 100%;
      p {
        color: #999;
        text-align: center;
        line-height: 60px;
        padding: 0 0 20px;
      }
    }
    .required {
      .van-field__label {
        span {
          position: relative;
          &::after {
            content: "*";
            color: #f00;
            position: absolute;
            left: 100%;
            top: 2px;
            margin-left: 10px;
          }
        }
      }
    }
    .mobile {
      color: #666;
    }
  }
  .btn-w {
    font-size: #{"14PX"};
    height: 80px;
  }
  .btn-group {
    background: #f77e5e;
    color: #fff;
  }
  .more-detail {
    position: absolute;
    bottom: 0;
    width: 100%;
    a {
      border: 0;
      border-radius: 0;
      border-bottom: 1px solid #000;
      height: 100px;
      line-height: 100px;
    }
    .close-detail {
      border: 0;
      margin-top: 20px;
      color: #333;
    }
  }
  .select {
    margin-bottom: 10px;
    height: 60px;
    border: 1px solid #ddd;
    padding-left: 10px;
    width: 80%;
    display: block;
    background: #fff;
  }
  .normal {
    text-align: left;
    color: #333;
  }

  .contribute-type {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}

.van-dialog__confirm,
.van-dialog__confirm:active {
  color: #f77e5e;
}
.input-btn {
  border-bottom: 0.0005rem solid #f0f0f0;
  padding: 0 0 10px 0;
  margin-top: 10px;
}
.ql-align-center {
  text-align: center;
}
.btngroup-tab{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1rem;
  border-bottom: 1px solid #eee;
}
.btngroup-tab>a{
  flex: 1;
  text-align: center;
  height: 100%;
  line-height: 1rem;
  font-size: .38rem;
  color: #555;
  position: relative;
}
.btngroup-tab>a.cur{
  color: #F77E5E;
}
.btngroup-tab>a.cur:after{
  content: "";
  display: block;
  width: .8rem;
  height: 4px;
  background: #f77e5e;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -.4rem;
}
.btn-backtop{
  position: fixed;
  right: .2rem;
  bottom: 2.5rem;
  width: 1rem;
  height: 1rem;
  transform: rotate(90deg);
}

.group-info-con{
  width: 100%;
  min-height: 2.2rem;
  background-size: 100% auto;
  padding-top: 1.8rem;
}
.group-item{
  width: 8.5rem;
  margin: 1.2rem auto;
}
.group-item .group-name{
  margin:0 auto;
  text-align: center;
  margin-bottom: .7rem;
}
.group-item .group-name span{
  height:1rem;
  line-height: 1rem;
  padding: 0 .5rem 0 .2rem;
  display: inline-block;
  background: #15559a;
  color: #fff;
  font-size: .38rem;
  position: relative;
}
.group-item .group-name span em{
  position: relative;
  z-index: 1;
}
.group-item .group-name span::before{
  content: "";
  width:.5rem;
  height:1rem;
  display: inline-block;
  background: url(../../assets/images/a-1.png) no-repeat top center;
  background-size: 100% 100%;
  position: absolute;
  left: -.5rem;
  top: 0;
  z-index: 0;
}
.group-item .group-name span::after{
  content: "";
  width: 100%;
  height: 1rem;
  display: inline-block;
  border: 2px solid #15559a;
  position:absolute;
  right: -.13rem;
  top: .1rem;
  z-index: 0;
}
.group-leader{
  width: 100%;
  height: 1rem;
  display: flex;
  justify-content:flex-start;
  align-items: center;
  background-color: #95b3d7;
  color: #fff;
  font-size: .36rem;
  position: relative;
}
.group-leader::before{
  content: "";
  width: .38rem;
  height: .32rem;
  display: inline-block;
  background: url(../../assets/images/a-2.png) no-repeat top center;
  background-size: 100% 100%;
  position:absolute;
  left: 0;
  top: 1rem;
}
.group-leader::after{
  content: "";
  width: .38rem;
  height: .32rem;
  display: inline-block;
  background: url(../../assets/images/a-3.png) no-repeat top center;
  background-size: 100% 100%;
  position:absolute;
  right: 0;
  top: 1rem;
}
.group-leader>div{
  text-align: center;
  line-height: 1rem;
  width:5.5rem;
}
.group-leader .label{
  width: 3rem;
  border-right: 2px solid #fff;
}
.group-members{
  width:7.74rem;
  display: flex;
  justify-content:space-between;
  align-items: center;
  border:2px solid #eee;
  border-top: 0;
  margin: 0 auto;
  font-size: .32rem;
}
.group-members .label{
  width: 2.74rem;
  background:#fff;
  text-align: center;
}
.group-members li{
  width:5rem;
  text-align: center;
  height:.8rem;
  line-height:.8rem;
  background-color: #f2f2f2;
  margin-top: 2px;
}
</style>
